<!-- #47 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Clients
      </div>
      <v-spacer></v-spacer>
      <v-btn
        @click="goToDetails(0)"
        color="primary"
        small
        v-if="checkPermission('app_client:client_create')"
        >Add Client</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="clients"
      :search="search"
      :loading="clientsLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <ConfirmDialog
          :dialog="dialogDelete"
          text="Are you sure you want to delete this item?"
          :loader="deleteLoader"
          @confirm="deleteItemConfirm"
          @close="closeDelete"
        />

        <template>
          <v-form
            @submit.prevent="searchAll"
            @keydown.enter.prevent
            type="submit"
          >
            <v-row class="custom-row pl-5">
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Client Legal Name"
                  v-model="name"
                  outlined
                  clearable
                  @click:clear="clearInput('this.name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Display Client Name"
                  v-model="display_client_name"
                  outlined
                  clearable
                  @click:clear="clearInput('this.display_client_name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="allClientServices"
                  outlined
                  v-model="service"
                  label="Service"
                  @click:clear="clearInput('this.service')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="allCountries"
                  outlined
                  v-model="country_code"
                  dense
                  chips
                  small-chips
                  label="Country"
                  @click:clear="clearInput('this.country_code')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Ramco Client Id"
                  v-model="ramco_client_id"
                  outlined
                  clearable
                  @click:clear="clearInput('this.ramco_client_id')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="Primary Email Id"
                  v-model="email"
                  outlined
                  clearable
                  @click:clear="clearInput('this.email')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="statuses"
                  outlined
                  v-model="active"
                  label="Status"
                  @click:clear="clearInput('this.active')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="settings"
                  outlined
                  v-model="settingUpdated"
                  label="Onboarding Status"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" class="text-end pr-4 mb-4 pb-4">
                <v-btn class="success" type="submit" color="primary"
                  >Search</v-btn
                >
                <v-btn color="white" class="ml-4" @click="clearAll"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
            <v-divider class="mb-2"></v-divider>
          </v-form>
        </template>
      </template>

      <template v-slot:item.settings_updated="{ item }">
        <span>
          {{
            item.settings_updated == 1
              ? "Complete"
              : item.settings_updated == 2
              ? "Not applicable"
              : "Pending"
          }}</span
        >
      </template>
      <template v-slot:[`item.active`]="{ item }">
        <v-switch
          v-model="item.active"
          @change="confirmStatusChange(item)"
          v-if="checkPermission('app_carrier_partner:carrier_update')"
        ></v-switch>
        <span v-else :class="item.active == true ? 'badge-active' : 'badge'">
          {{ item.active == true ? "Active" : "In-active" }}
        </span>
      </template>
      <template v-slot:[`item.range_limit`]="{ item }">
        {{ item.range_limit | numFormat }}
      </template>
      <template v-slot:[`item.min_utilization`]="{ item }">
        {{ item.min_utilization | numFormat }}%
      </template>
      <template v-slot:[`item.service`]="{ item }">
        {{ getServiceName(item.service) }}
      </template>
      <template v-slot:[`item.client_key`]="{ item }">
        {{ item.client_key == null ? "Inactive" : "Active" }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_client:client_crud_api_model_action')"
          >
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="inviteClient(item)"
            >
              mdi-email
            </v-icon>
          </template>
          <span>Send Invitation</span>
        </v-tooltip> -->
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_client:client_edit')"
          >
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="goToDetails(item.id)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.base_64_logo">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="(opendialog = true), (base_64_logo = item.base_64_logo)"
            >
              mdi-image
            </v-icon>
          </template>
          <span>Logo</span>
        </v-tooltip>
        <v-icon></v-icon>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_client:client_address_list')"
          >
            <v-icon
              small
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="goToddress(item)"
            >
              mdi-map-marker
            </v-icon>
          </template>
          <span>View Address</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_client:client_generate_token_list')"
          >
            <v-icon
              small
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="token(item)"
            >
              mdi-key
            </v-icon>
          </template>
          <span>View Token</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.service == 'ior'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="goToMapping(item)"
            >
              mdi-arrow-left-right
            </v-icon>
          </template>
          <span>Product Code and HS Code mapping</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            item.service == 'ior' &&
            checkPermission('app_seller:mapped_seller_list')
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" @click="goToMapSeller(item)">
              mdi-plus
            </v-icon>
          </template>
          <span>Map Sellers</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="checkPermission('app_client:client_settings_create_or_edit')"
          >
            <v-icon
              small
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="setting(item)"
            >
              mdi-cog
            </v-icon>
          </template>
          <span>Settings</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="goToLinehaul(item)"
            >
              mdi-map-marker
            </v-icon>
          </template>
          <span>Allocation Rules</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            userCategory.user_category === 3 &&
            checkPermission('app_sub_accounts:user_sub_user_api_list_create')
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              @click="goToUser(item)"
            >
              mdi-account
            </v-icon>
          </template>
          <span>User List</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="opendialog" max-width="600px" max-height="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Uploaded Logo </span>
          <v-spacer />
          <v-btn icon @click="opendialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-img :src="base_64_logo"></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="dialogConfirm"
      text="Are you sure want to change status?"
      :loader="statusLoader"
      @confirm="changeStatus"
      @close="closeConfirm"
    />
    <ConfirmDialog
      :dialog="dialogInvite"
      text="Are you sure want to send invitation email?"
      :loader="inviteLoader"
      @confirm="sendInvite"
      @close="dialogInvite = false"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { countries, clientServices } from "@/config/data";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";
export default {
  components: {
    ConfirmDialog,
  },
  computed: {
    ...mapGetters(["trackCategories", "userCategory"]),
    formTitle() {
      return this.editedIndex === -1 ? "Create" : "Edit";
    },
    allCountries() {
      return Object.keys(countries).map((i) => {
        return {
          text: countries[i],
          value: i,
        };
      });
    },
    allClientServices() {
      return Object.keys(clientServices).map((i) => {
        return {
          text: clientServices[i],
          value: i,
        };
      });
    },
  },

  data: () => ({
    base_64_logo: null,
    opendialog: false,
    settingUpdated: null,
    settings: [
      {
        text: "Completed",
        value: 1,
      },
      {
        text: "Pending",
        value: 0,
      },
      {
        text: "Not Applicable",
        value: 2,
      },
    ],
    statuses: [
      {
        text: "Active",
        value: "True",
      },
      {
        text: "Inactive",
        value: "False",
      },
    ],
    dialog: false,
    dialogDelete: false,
    dialogConfirm: false,
    headers: [
      {
        text: "Client Legal  Name",
        value: "name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Display Client Name",
        value: "display_client_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Service",
        value: "service",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Country",
        value: "country_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Ramco Client ID",
        value: "ramco_client_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Primary Email Id",
        value: "email",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Settings Updated",

        value: "settings_updated",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "active",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      display_client_name: "",
      client_website: "",
      country_code: "",
      active: null,
      email: null,
      status: "",
      service: "",
      ramco_client_id: "",
      contact_name: "",
      contact_phone_no: "",
      crm_value: "",
      url_value: "",
      type_of_business: "",
      zone: "",
    },
    defaultItem: null,
    clients: [],
    options: {},
    total: 0,
    clientsLoader: false,
    search: null,
    saveLoader: false,
    deleteLoader: false,
    statusLoader: false,
    dialogInvite: false,
    inviteLoader: false,
    name: "",
    display_client_name: "",
    email: "",
    country_code: "",
    service: "",
    active: "",
    filtersArr: {},
    business: ["B2C", "B2B"],
    zones: ["Local", "Freezone"],
    ramco_client_id: null,
  }),

  watch: {
    dialog(val) {
      val || this.close();
      if (this.editedIndex === -1) {
        this.editedItem = Object.assign({}, this.defaultItem);
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    options: {
      handler() {
        this.fetchClients();
      },
      deep: true,
    },
    search() {
      this.fetchClients();
    },
  },

  created() {
    this.defaultItem = Object.assign({}, this.editedItem);
  },

  methods: {
    ...mapActions([
      "getClients",
      "createClient",
      "updateClient",
      "deleteClient",
      "sendClientInvite",
      "snackBar",
      "generateToken",
      "getTokenList",
      "updateTokenList",
    ]),
    goToDetails(id) {
      this.$router.push({
        name: "clientDetails",
        params: {
          id,
        },
      });
    },
    goToUser(item) {
      let id = item.id;
      this.$router.push({
        name: "UsersList",
        params: {
          id,
        },
      });
    },
    goToLinehaul(item) {
      let id = item.id;
      this.$router.push({
        name: "Linehaul",
        params: {
          id,
        },
      });
    },
    fetchClients() {
      this.clients = [];
      this.clientsLoader = true;
      this.getClients({
        ...this.options,
        ...this.filtersArr,
        search: this.search,
      })
        .then((res) => {
          this.clientsLoader = false;
          this.clients = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.clientsLoader = false;
        });
    },

    editItem(item) {
      this.editedIndex = this.clients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.clients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    inviteClient(item) {
      this.editedIndex = this.clients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogInvite = true;
    },

    deleteItemConfirm() {
      this.deleteLoader = true;
      this.deleteClient(this.clients[this.editedIndex].id)
        .then((res) => {
          this.deleteLoader = false;
          this.clients.splice(this.editedIndex, 1);
          this.closeDelete();
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
        })
        .catch(() => {
          this.deleteLoader = false;
        });
    },

    reset() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form?.reset();
      });
    },

    close() {
      this.dialog = false;
      this.reset();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.reset();
    },

    closeConfirm() {
      this.dialogConfirm = false;
      this.clients[this.editedIndex].active = this.clients[this.editedIndex]
        .active
        ? false
        : true;
      this.reset();
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      if (this.editedIndex > -1) {
        this.updateClient({
          id: this.editedItem.id,
          data: this.editedItem,
        })
          .then((res) => {
            this.fetchClients();
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.close();
          })
          .catch(() => {
            this.saveLoader = false;
          });
      } else {
        this.createClient(this.editedItem)
          .then((res) => {
            this.fetchClients();
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.close();
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
    confirmStatusChange(item) {
      this.editedIndex = this.clients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogConfirm = true;
    },

    changeStatus() {
      this.statusLoader = true;
      this.editedItem.active = this.editedItem.active ? "true" : "false";
      var formData = new FormData();
      for (let key in this.editedItem) {
        if (this.editedItem[key] !== null && this.editedItem[key] !== "") {
          formData.append(key, this.editedItem[key]);
        }
      }
      this.updateClient({
        id: this.editedItem.id,
        data: formData,
      })
        .then((res) => {
          this.statusLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogConfirm = false;
          this.reset();
        })
        .catch(() => {
          this.statusLoader = false;
          this.closeConfirm();
        });
    },

    sendInvite() {
      this.inviteLoader = true;
      this.sendClientInvite({
        client_ids: [this.editedItem.id],
      })
        .then((res) => {
          this.inviteLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogInvite = false;
        })
        .catch(() => {
          this.inviteLoader = false;
        });
    },

    goToMapping(item) {
      this.$router.push({
        name: "ProductHSCodeMap",
        params: {
          id: item.id,
        },
        query: {
          name: item.name,
        },
      });
    },

    goToMapSeller(item) {
      this.$router.push({
        name: "MapSellers",
        params: {
          id: item.id,
        },
        query: {
          name: item.name,
        },
      });
    },

    goToddress(item) {
      this.$router.push({
        name: "ClientAddresses",
        params: {
          id: item.id,
        },
      });
    },

    clearInput(val) {
      if (val !== null) {
        val = "";
      }
    },
    clearAll() {
      (this.name = ""),
        (this.display_client_name = ""),
        (this.email = ""),
        (this.country_code = ""),
        (this.service = ""),
        (this.active = ""),
        (this.ramco_client_id = "");
      this.settingUpdated = null;
      this.searchAll();
    },

    allFilters() {
      this.clientsLoader = true;
      let obj = {
        name: this.name,
        display_client_name: this.display_client_name,
        email: this.email,
        country_code: this.country_code,
        service: this.service,
        active: this.active,
        ramco_client_id: this.ramco_client_id,
        settings_updated: this.settingUpdated,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getClients({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.clientsLoader = false;
          this.clients = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.clientsLoader = false;
        });
    },
    token(item) {
      this.$router.push({
        name: "ClientToken",
        params: {
          id: item.id,
        },
      });
    },
    setting(item) {
      this.$router.push({
        name: "ClientSettings",
        params: {
          id: item.id,
          status: item.active,
        },
      });
    },
    tokenList(item) {
      this.tokenListDialog = true;
      this.clientId = item.id;
      this.tokenLoader = true;
      this.getTokenList(item.id)
        .then((res) => {
          this.keyList = res.data.records;
          this.tokenLoader = false;
        })
        .catch(() => {
          this.tokenLoader = false;
        });
    },
    tokenStatusChange(item) {
      let payload = {
        client_id: this.clientId,
        id: item.id,
        status: item.client_key_status,
      };
      this.updateTokenList(payload).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.message,
        });
        this.tokenListDialog = false;
      });
    },
    getServiceName(key) {
      return clientServices[key];
    },
  },
};
</script>
<style>
.custom-row label.v-label.theme--light {
  top: 15px !important;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.custom-icon-size .v-icon.v-icon {
  font-size: 22px !important;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
